import {
  USERSETTINGS_CHANGE, USER_DROPFILE,
  CURRENT_USER_LOADED
} from '../../actions';

const currentUserReducer = (oldState = {
  currentUserVm: {
    email: '',
    gender: '',
    birthday: '',
    name: '',
    prename: '',
    aboutMe: '',
    streetnr: '',
    photoURL: '',
    isPate: new Set(),
    isOwner: new Set(),
    landScapeSituation: '',
    displayName: '',
    pricePerDayAtYou: '',
    pricePerDayAtMe: '',
    priceClean: '',
    pricePerNight: '',
    place: '',
    houseSituation: '',
    profileIsValid: undefined
  }
}, action) => {
  const { currentUserVm } = oldState;
  switch (action.type) {
    case USERSETTINGS_CHANGE: {
      const { name, value } = action;
      if ((currentUserVm[name]) instanceof Set) {
        if (currentUserVm[name].has(value)) {
          currentUserVm[name].delete(value);
        } else {
          currentUserVm[name].add(value);
        }
        return { ...oldState, requestVm: { ...currentUserVm, [name]: new Set(currentUserVm[name]) } };
      }

      return {
        ...oldState,
        currentUserVm: {
          ...currentUserVm,
          [name]: value
        }
      };
    }
    case USER_DROPFILE:
      return {
        ...oldState,
        currentUserVm: {
          ...currentUserVm,
          photoURL: action.secureUrl,
        }
      };
    case CURRENT_USER_LOADED:
    {
      const { response } = action;
      return {
        ...oldState,
        currentUserVm: {
          ...currentUserVm,
          ...response,
          profileIsValid: (response && response.profileIsValid) || false,
          isPate: (response && new Set([`${response.isPate}`])) || new Set([]),
          isOwner: (response && new Set([`${response.isOwner}`])) || new Set([]),
        }
      };
    }
    default:
      return oldState;
  }
};

export default currentUserReducer;



// WEBPACK FOOTER //
// ./src/pages/Usersettings/currentUserReducer.js